import { Card, Stack, Text } from 'components'
import { createStyles } from '@mantine/core'
import { ReactNode } from 'react'

const useStyles = createStyles(theme => ({
  card: {
    transition: 'transform 150ms ease, box-shadow 150ms ease',
    '&:hover': {
      transform: 'translateY(-2px)',
      boxShadow: theme.shadows.md,
    },
  },
}))

interface ArticleListCardProps {
  emptyMessage: string
  isEmpty: boolean
  children: ReactNode
}

// Shared card shell around an article list, with the subtle lift-on-hover
// used across the Arc settings cards.
export const ArticleListCard = ({ emptyMessage, isEmpty, children }: ArticleListCardProps) => {
  const { classes } = useStyles()

  return (
    <Card className={classes.card} withBorder radius='lg' padding='lg'>
      {isEmpty ? (
        <Text color='dimmed' size='sm'>
          {emptyMessage}
        </Text>
      ) : (
        <Stack spacing={2}>{children}</Stack>
      )}
    </Card>
  )
}
